// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3yq5O","title":"AfterFrontImage_title__KbOT1"};